// Footer legado: agora usa o footer do novo design (mesma API: <Footer />).
import FooterNew from "@/components/footer/Footer";

export default function Footer() {
  return <FooterNew />;
}
